import React, { useContext, useEffect, useState } from "react";
import { YMaps, Map, Placemark, ZoomControl } from "@pbe/react-yandex-maps";
import { TextContext } from "../context/TextContext";
import { NavContext, showedNav } from "../context/NavState";

export default () => {
  //properties={{iconContent:`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
  //     <g>
  //         <path d="M46.844,52.451l0,28.688c0,1.741 1.414,3.155 3.156,3.155c1.742,0 3.156,-1.414 3.156,-3.155l-0,-28.688c11.661,-1.545 20.673,-11.539 20.673,-23.622c0,-13.151 -10.677,-23.829 -23.829,-23.829c-13.152,0 -23.829,10.678 -23.829,23.829c-0,12.083 9.012,22.077 20.673,23.622Zm3.156,-41.139c9.668,-0 17.518,7.849 17.518,17.517c-0,9.669 -7.85,17.518 -17.518,17.518c-9.668,0 -17.518,-7.849 -17.518,-17.518c0,-9.668 7.85,-17.517 17.518,-17.517Zm0.085,11.638c3.536,-0.095 6.234,1.273 7.896,4.449c0.808,1.543 2.717,2.14 4.26,1.332c1.543,-0.808 2.14,-2.716 1.332,-4.26c-2.888,-5.516 -7.516,-7.996 -13.658,-7.83c-1.741,0.047 -3.117,1.498 -3.07,3.24c0.047,1.741 1.499,3.116 3.24,3.069Z"/>
  //         <path d="M65.762,73.642c6.842,1.017 12.43,2.638 15.789,4.715c0.697,0.431 1.282,0.873 1.721,1.343c0.288,0.308 0.549,0.577 0.549,0.913c-0,0.459 -0.404,0.803 -0.857,1.216c-1.005,0.916 -2.49,1.736 -4.333,2.5c-6.457,2.674 -16.885,4.359 -28.631,4.359c-11.746,0 -22.174,-1.685 -28.631,-4.359c-1.843,-0.764 -3.328,-1.584 -4.333,-2.5c-0.453,-0.413 -0.857,-0.757 -0.857,-1.216c0,-0.347 0.274,-0.623 0.576,-0.941c0.457,-0.482 1.065,-0.934 1.791,-1.374c3.469,-2.107 9.233,-3.741 16.272,-4.74c1.724,-0.245 2.926,-1.844 2.681,-3.569c-0.245,-1.724 -1.844,-2.925 -3.569,-2.681c-9.576,1.36 -17.045,3.994 -20.697,7.033c-2.309,1.922 -3.366,4.109 -3.366,6.272c0,2.736 1.809,5.61 5.691,7.883c6.461,3.783 19.452,6.504 34.442,6.504c14.99,-0 27.981,-2.721 34.442,-6.504c3.882,-2.273 5.691,-5.147 5.691,-7.883c-0,-2.136 -1.03,-4.294 -3.278,-6.197c-3.549,-3.005 -10.812,-5.626 -20.165,-7.017c-1.723,-0.257 -3.329,0.934 -3.586,2.657c-0.256,1.723 0.935,3.33 2.658,3.586Z"/>
  //     </g>
  // </svg>`}}
  const { data: setting } = useContext(TextContext);
  const { origNavigation, setNavigationContext } = useContext(NavContext);
  const [mapPoints, setMapPoints] = useState([55.883546, 37.554014]);
  useEffect(() => {
    if (setting.phone || setting.address || setting.email) {
      showedNav.add("map");
      setNavigationContext(origNavigation.filter((el) => showedNav.has(el.to)));
      if (setting.points?.length) {
        const [n1, n2] = setting.points.split(", ").map(parseFloat);
        setMapPoints([n1, n2]);
      }
    }
  }, [setting]);
  return (
    <div className="blockContent">
      <div className="block" style={{ marginTop: "0" }}>
        <div className="titles">Контакты</div>
        <div className="contacts">
          <div className="contactsBlocks">
            <OneContact
              title={"Фактический адрес"}
              text={
                setting.address ??
                "127591, г. Москва, Дмитровское шоссе, 102Ас4"
              }
            />
            <OneContact
              title={"Электронная почта"}
              text={setting.email ?? "mossteklo24@mail.ru"}
            />
            <OneContact title={"Телефон"} text={"+79775304925"} />
          </div>
          <div className="contactsBlocks">
            <div className="contactsItemTitle">Реквизиты</div>
            <p className="contactsItemText">
              ИП {setting.IP ?? "Кузьмин Сергей Сергеевич"}
            </p>
            <p className="contactsItemText">
              ИНН {setting.INN ?? 770803850471}
            </p>
            <p className="contactsItemText">
              ОГРНИП {setting.OGRNIP ?? 320774600521799}
            </p>
          </div>
        </div>
        <div style={{ borderRadius: "10px", overflow: "hidden" }}>
          <YMaps>
            <Map
              id="map"
              width={"100%"}
              height={"40vh"}
              defaultState={{ center: mapPoints, zoom: 17 }}
              instanceRef={(ref) => ref?.behaviors?.disable?.("scrollZoom")}
            >
              <Placemark
                options={{
                  iconColor: "black",
                  iconContentSize: [100, 100],
                  iconContentOffset: [10, 10],
                }}
                geometry={mapPoints}
              />
              <ZoomControl />
            </Map>
          </YMaps>
        </div>
      </div>
    </div>
  );
};

const OneContact = ({ title, text }) => (
  <>
    <div className="contactsItemTitle">{title}</div>
    <p className="contactsItemText">{text}</p>
  </>
);
